import { Button, Input, Label, Spinner } from '@repo/ui'
import { createFileRoute, Link } from '@tanstack/react-router'
import { CheckCircle2 } from 'lucide-react'
import { type FormEvent, useState } from 'react'
import { toast } from 'sonner'

import { AuthShell } from '@/components/auth/auth-shell'
import { authApi } from '@/lib/api'

export const Route = createFileRoute('/esqueci-senha')({
  component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [sent, setSent] = useState(false)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    const trimmedEmail = email.trim()

    if (!trimmedEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      toast.error('Informe um email válido')
      return
    }

    setSubmitting(true)

    try {
      const redirectTo = `${window.location.origin}/redefinir-senha`
      await authApi.post('/api/auth/request-password-reset', {
        email: trimmedEmail,
        redirectTo,
      })
      setSent(true)
    } catch {
      setSubmitting(false)
      return
    }

    setSubmitting(false)
  }

  if (sent) {
    return (
      <AuthShell
        title="Email enviado"
        subtitle="Verifique sua caixa de entrada"
      >
        <div className="flex flex-col items-center gap-4 py-4 text-center">
          <CheckCircle2 className="text-success h-12 w-12" />
          <p className="text-muted-foreground text-sm">
            Enviamos um link de redefinição para <strong>{email}</strong>.
            Verifique também a pasta de spam.
          </p>
          <Link
            to="/entrar"
            search={{ returnTo: undefined }}
            className="text-primary text-sm font-medium hover:underline"
          >
            Voltar para o login
          </Link>
        </div>
      </AuthShell>
    )
  }

  return (
    <AuthShell
      title="Recuperar senha"
      subtitle="Enviaremos um link para o seu email"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <Button type="submit" className="w-full" disabled={submitting}>
          {submitting ? <Spinner /> : null}
          Enviar link de recuperação
        </Button>
      </form>
      <p className="text-muted-foreground mt-6 text-center text-sm">
        Lembrou a senha?{' '}
        <Link
          to="/entrar"
          search={{ returnTo: undefined }}
          className="text-primary font-medium hover:underline"
        >
          Entrar
        </Link>
      </p>
    </AuthShell>
  )
}
